import Block from 'components/Block'
import { Image } from 'components/Image'
import TextBodyMedium from 'components/TextBodyBig'
import TextTitleCondensedBig from 'components/TextTitleCondensedBig.js'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import {
  STYLES_BORDER_RADIUS,
  STYLES_BOX_SHADOW
} from 'modules/styles/constants/index.cjs'
import React from 'react'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import GetCoachingButton from 'components/GetCoachingButton/index.js'
import Flex from 'components/Flex/index.js'
import toDomAnchorIdStringUtil from 'utils/string/to-dom-anchor-id/index.js'
import { FeatureCTA } from './Cta'
import {
  FEATURE_DESCRIPTION_MESSAGES,
  FEATURE_IMAGE_SOURCES,
  FEATURE_MESSAGES
} from 'modules/app/constants/features/index.js'
import { useTheme } from 'modules/styles/index.js'

export function AppFeatures ({
  invertColors
}) {
  const intl = useIntl()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const theme = useTheme()

  return (
    <View>
      {
        FEATURE_MESSAGES.map((message, index) => {
          const imageSource = FEATURE_IMAGE_SOURCES[index]
          const isPair = !(index % 2)
          const isCoaching = false

          let imageWrapperStyle
          let textStyle = {
            whiteSpace: 'pre-line'
          }

          if (
            !isSmallScreen &&
            isPair
          ) {
            textStyle = {
              ...textStyle,
              width: '100%',
              textAlign: 'left'
            }
            imageWrapperStyle = {
              alignItems: View.ALIGN.END
            }
          } else if (!isSmallScreen) {
            textStyle = {
              ...textStyle,
              width: '100%',
              textAlign: 'right'
            }
            imageWrapperStyle = {
              alignItems: View.ALIGN.START
            }
          } else if (isSmallScreen) {
            textStyle = {
              ...textStyle,
              textAlign: 'center'
            }
          }

          const renderImage = () => {
            if (!imageSource) {
              return <></>
            }
            const style = (
              imageWrapperStyle || {}
            )
            return (
              <View
                style={{
                  flex: '1',
                  ...style
                }}
              >
                <Image
                  style={{
                    width: '18.5em',
                    borderRadius: STYLES_BORDER_RADIUS.MEDIUM,
                    boxShadow: STYLES_BOX_SHADOW.NORMAL
                  }}
                  src={imageSource}
                  shouldLazyLoad
                  alt={formatMessageIntlUtil(intl, message)}
                />
              </View>
            )
          }

          const renderLeftOrTopImage = () => {
            if (
              !imageSource || (
                isPair &&
                !isSmallScreen
              )
            ) {
              return
            }

            return renderImage()
          }

          const renderRightOrBottomImage = () => {
            if (
              !imageSource ||
              !isPair ||
              isSmallScreen
            ) {
              return
            }

            return renderImage()
          }

          const descriptionMessage = FEATURE_DESCRIPTION_MESSAGES[index]
          let bgc
          if (isPair) {
            bgc = invertColors
              ? 'background'
              : 'backgroundContent'
          } else {
            bgc = invertColors
              ? 'backgroundContent'
              : 'background'
          }

          const title = formatMessageIntlUtil(intl, message)
          // TODO only in english
          const id = toDomAnchorIdStringUtil(title)

          let alignItems
          if (isSmallScreen) {
            alignItems = 'center'
          } else if (isPair) {
            alignItems = 'flex-start'
          } else {
            alignItems = 'flex-end'
          }
          return (
            <Block
              key={index}
              bgc={bgc}
              id={id}
            >
              <View
                style={{
                  flexDirection: isSmallScreen
                    ? View.DIRECTION.COLUMN
                    : View.DIRECTION.ROW,
                  justifyContent: View.JUSTIFY.CENTER,
                  alignItems: View.ALIGN.CENTER,
                  width: '100%',
                  maxWidth: theme.maxWidth.desktopCompact
                }}
              >
                {renderLeftOrTopImage()}

                <View
                  mt={isSmallScreen ? 2 : 0}
                  style={{
                    flex: '1'
                  }}
                  ac={alignItems}
                >
                  <TextTitleCondensedBig
                    style={textStyle}
                  >
                    {title}
                  </TextTitleCondensedBig>
                  {
                    descriptionMessage && (
                      <TextBodyMedium
                        mt={0.5}
                        style={textStyle}
                      >
                        {formatMessageIntlUtil(intl, descriptionMessage)}
                      </TextBodyMedium>
                    )
                  }

                  {
                    !isPair &&
                    !isCoaching && (
                      <FeatureCTA />
                    )
                  }

                  {
                    isCoaching && (
                      <Flex
                        style={{
                          alignItems: isPair
                            ? 'flex-start'
                            : 'flex-end'
                        }}
                      >
                        <GetCoachingButton
                          mt={2}
                          w={
                            isSmallScreen
                              ? '100%'
                              : '200px'
                          }
                        />
                      </Flex>
                    )
                  }
                </View>

                {renderRightOrBottomImage()}
              </View>
            </Block>
          )
        })
      }
    </View>
  )
}
